// @noflow
import './pin-input.component.css';

import React, { Component } from 'react';

import classnames from 'classnames';
import { getDOMOnlyProps } from '~/core/utils/form/form-helpers';
import { isDependentOn } from '~/core/utils/custom-prop-types';
import PropTypes from 'prop-types';

/* eslint-disable react/prefer-stateless-function */

const backSpaceKey = 8;
const shiftKey = 16;
const tabKey = 9;

// This needs to be a class so that it has a backing instance and can have refs
// placed on it in `PinInputGroup`.
export default class PinInput extends Component {
    static propTypes = {
        'aria-label': PropTypes.string.isRequired,
        className: PropTypes.string,
        onFocus: PropTypes.func,
        onKeyUp: PropTypes.func,
        onPinDeleted: PropTypes.func,
        onPinEntered: PropTypes.func,
        onPinFocused: PropTypes.func,
        pinIndex: isDependentOn('onPinEntered', (_, onPinEntered) => onPinEntered, PropTypes.number),
        value: PropTypes.string
    };

    handleOnKeyUp = e => {
        const { onKeyUp, onPinDeleted, onPinEntered, pinIndex, value } = this.props;

        onKeyUp && onKeyUp(e);

        const keyCode = e.keyCode;
        const shiftHeld = e.shiftKey;

        if (!value && keyCode === backSpaceKey) {
            onPinDeleted && onPinDeleted(this, pinIndex);
            return;
        }

        if (value && value.length === 1 && keyCode !== shiftKey && (keyCode !== tabKey && !shiftHeld)) {
            onPinEntered && onPinEntered(this, pinIndex);
        }
    };

    handleOnFocus = e => {
        const { onPinFocused, pinIndex, onFocus } = this.props;
        onPinFocused && onPinFocused(pinIndex);
        onFocus && onFocus(e);
    };

    render() {
        const {
            /* eslint-disable no-unused-vars */
            className,
            onPinDeleted,
            onPinEntered,
            onPinFocused,
            pinIndex,
            /* eslint-enable no-unused-vars */
            ...props
        } = this.props;

        return (
            <input
                {...getDOMOnlyProps(props)}
                className={classnames('pin-input', className)}
                onFocus={this.handleOnFocus}
                onKeyUp={this.handleOnKeyUp}
            />
        );
    }
}
/* eslint-enable react/prefer-stateless-function */



// WEBPACK FOOTER //
// ./src/components/widgets/pin-input/pin-input.component.js